export default __webpack_public_path__ + "assets/system.dabc4874.svg";